package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * KPI stat tile (Stitch admin/dashboard "bento" cards): tinted icon chip, label, large value, and an
 * optional caption. [accentColor]/[accentContainer] tint the icon chip (e.g. primary/categoryChip,
 * error/errorContainer for attention tiles); the caption inherits [captionColor] so alert captions
 * can read as errors. All text is localized by the caller.
 */
@Composable
fun StatTile(
    iconName: String,
    label: String,
    value: String,
    modifier: Modifier = Modifier,
    caption: String? = null,
    accentColor: Color = AppTheme.colors.primary,
    accentContainer: Color = AppTheme.colors.categoryChip,
    captionColor: Color = AppTheme.colors.onSurfaceVariant,
) {
    AppCard(modifier = modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        ) {
            Box(
                modifier = Modifier
                    .size(AppTheme.sizes.iconCircle)
                    .background(accentContainer, AppTheme.shapes.md),
                contentAlignment = Alignment.Center,
            ) {
                AppIcon(name = iconName, size = AppTheme.sizes.iconMd, tint = accentColor)
            }
            Text(
                text = label,
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
                modifier = Modifier.padding(top = AppTheme.spacing.sm),
            )
            Text(
                text = value,
                style = AppTheme.typography.headlineLg,
                color = AppTheme.colors.onSurface,
            )
            if (caption != null) {
                Text(
                    text = caption,
                    style = AppTheme.typography.labelSm,
                    color = captionColor,
                )
            }
        }
    }
}
